// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.matchCss_m1gwp767 span{color:var(--gray100);font-weight:bold;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-ui-autosuggest/dist/es/AutosuggestList.css"],"names":[],"mappings":"AAAA,wBAAwB,oBAAoB,CAAC,gBAAgB,CAAC","sourcesContent":[".matchCss_m1gwp767 span{color:var(--gray100);font-weight:bold;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
